var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card-title', [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-account ")]), _c('span', {
    staticClass: "font-size-14 font-weight-regular"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }